import * as actionTypes from "./actionTypes";

const initialState = {
    values: {},
    loading: false,
    table: {
        data: [],
        sort: {
            property: undefined,
            direction: undefined
        },
        totalElements: undefined,
        pageNumber: undefined,
        totalPages: undefined
    },
    //form specific:
    terminalData: {},

    terminalList: [],

    loadingCreateRequest: false,
    loadingEditRequest: false,
    loadingDeleteRequest: false,

    terminalWasCreated: false,
    terminalWasEdited: false,
    terminalWasDeleted: false,

    terminalProfilesList: [],

    error: undefined
};

const terminalsReducer = (state = initialState, {type, payload}) => {
    switch (type) {
        case actionTypes.GET_TERMINAL_LIST_REQUEST:
            return {
                ...state,
                loadingListRequest: true
            };
        case actionTypes.GET_TERMINAL_LIST_SUCCESS:
            return {
                ...state,
                loadingListRequest: false,
                terminalList: payload
            };
        case actionTypes.GET_TERMINAL_LIST_FAILED:
            return {
                ...state,
                loadingListRequest: false,
            };

        case actionTypes.TERMINAL_SEARCH_REQUEST:
            return {
                ...state,
                loading:true
            };
        case actionTypes.TERMINAL_SEARCH_SUCCESS:
            return {
                ...state,
                loading:false,
                table: {
                    ...state.table,
                    data: payload.content,
                    totalPages: payload.totalPages,
                    totalElements: payload.totalElements,
                    sort: {
                        direction: payload.sort[0].direction,
                        property: payload.sort[0].property,
                    },
                    pageSize: payload.pageable.pageSize,
                    pageNumber: payload.pageable.pageNumber
                }
            };
        case actionTypes.GET_TERMINAL_REQUEST:
            return {
                ...state,
                loading:true,
            };
        case actionTypes.GET_TERMINAL_SUCCESS:
            return {
                ...state,
                loading: false,
                terminalData: payload,
            };
        case actionTypes.GET_TERMINAL_FAILED:
            return {
                ...state,
                loading: false,
            };
        case actionTypes.DELETE_TERMINAL_REQUEST:
            return {
                ...state,
                loadingDeleteRequest: true
            };
        case actionTypes.DELETE_TERMINAL_SUCCESS:
            return {
                ...state,
                loadingDeleteRequest: false,
                terminalWasDeleted: true
            };
        case actionTypes.DELETE_TERMINAL_FAILED:
            return {
                ...state,
                loadingDeleteRequest: false,
                terminalWasDeleted: false
            };
        case actionTypes.EDIT_TERMINAL_REQUEST:
            return {
                ...state,
                loadingEditRequest: true
            };
        case actionTypes.EDIT_TERMINAL_SUCCESS:
            return {
                ...state,
                loadingEditRequest: false,
                terminalWasEdited: true
            };
        case actionTypes.EDIT_TERMINAL_FAILED:
            return {
                ...state,
                loadingEditRequest: false,
                terminalWasEdited: false
            };
        case actionTypes.CREATE_TERMINAL_REQUEST:
            return {
                ...state,
                loadingCreateRequest: true
            };
        case actionTypes.CREATE_TERMINAL_SUCCESS:
            return {
                ...state,
                loadingCreateRequest: false,
                terminalWasCreated: true
            };
        case actionTypes.CREATE_TERMINAL_FAILED:
            return {
                ...state,
                loadingCreateRequest: false,
                terminalWasCreated: false
            };
        case actionTypes.RESET_TERMINAL_FORM:
            return {
                ...state,
                terminalData: {},
                loadingCreateRequest: false,
                loadingEditRequest: false,
                loadingDeleteRequest: false,
                terminalWasCreated: false,
                terminalWasEdited: false,
                terminalWasDeleted: false,
                error: undefined
            };
        case actionTypes.GET_TERMINAL_PROFILE_LIST_REQUEST:
            return {
                ...state,
                loadingTerminalProfiles: true,
            }
        case actionTypes.GET_TERMINAL_PROFILE_LIST_FAILED:
            return {
                ...state,
                loadingTerminalProfiles: false,
            }
        case actionTypes.GET_TERMINAL_PROFILE_LIST_SUCCESS:
            return {
                ...state,
                loadingTerminalProfiles: false,
                terminalProfilesList: payload
            }
        default:
            return state;
    }
};

export default terminalsReducer;